<template>
    <div class="mt-3">
        <UiMessage v-if="errorMessage" :text="errorMessage" type="error" />

        <div
            v-if="isLoaded"
            class="pilulka-premium-payment__voucher-section"
            :class="{ 'pilulka-premium-payment__grey-db': voucherSectionOpened }"
            @click="openVoucherSection"
        >
            {{ $t('cart.premiumBox.haveVoucher') }}

            <div v-if="voucherSectionOpened && !voucherConfirmed" class="pilulka-premium-payment__voucher-content" @click.stop>
                <label for="voucherCode" class="pilulka-premium-payment__voucher-label">
                    {{ $t('cart.premiumBox.voucherCode') }}
                </label>
                <input
                    id="voucherCode"
                    v-model="voucherCode"
                    type="text"
                    class="pilulka-premium-payment__voucher-input"
                    :placeholder="$t('cart.premiumBox.voucherCodePlaceholder')"
                    :disabled="isCalculatingPrice"
                    @keyup.enter="confirmVoucher"
                />
                <UiMessage v-if="voucherErrorMessage" :text="voucherErrorMessage" type="error" class="mb-3 mt-0" />
                <button
                    class="btn btn-primary pilulka-premium-payment__voucher-button"
                    :disabled="!voucherCode.trim() || isCalculatingPrice"
                    @click.stop="confirmVoucher"
                >
                    <span v-if="isCalculatingPrice">{{ $t('cart.premiumBox.calculating') }}</span>
                    <span v-else>{{ $t('cart.premiumBox.applyVoucher') }}</span>
                </button>
            </div>

            <div v-if="voucherConfirmed" class="pilulka-premium-payment__voucher-confirmed" @click.stop>
                <div class="pilulka-premium-payment__voucher-confirmed-content">
                    <div class="pilulka-premium-payment__voucher-confirmed-icon">
                        <i class="fas fa-check-circle"></i>
                    </div>
                    <div class="pilulka-premium-payment__voucher-confirmed-text">
                        <div>{{ $t('cart.premiumBox.voucherWillBeApplied', { code: voucherCode }) }}</div>
                        <div v-if="calculatedPrice !== null && originalPrice !== null" class="pilulka-premium-payment__price-info">
                            <span class="pilulka-premium-payment__original-price">{{ $formatCurrency(originalPrice) }}</span>
                            <span class="pilulka-premium-payment__final-price">{{ $formatCurrency(calculatedPrice) }}</span>
                        </div>
                    </div>
                </div>
                <div class="pilulka-premium-payment__voucher-actions">
                    <button class="pilulka-premium-payment__voucher-change" @click.stop="changeVoucher">
                        {{ $t('cart.premiumBox.changeVoucher') }}
                    </button>
                    <button class="pilulka-premium-payment__voucher-remove" @click.stop="removeVoucher">
                        {{ $t('cart.premiumBox.removeVoucher') }}
                    </button>
                </div>
            </div>
        </div>

        <div
            v-if="userCreditCards.length > 0 && isLoaded"
            class="pilulka-premium-payment__remembered-credit-cards"
            :class="{ 'pilulka-premium-payment__grey-db': rememberedCreditCardsOpened }"
            @click="openRememberedCreditCards"
        >
            {{ $t('cart.premiumBox.rememberedCreditCards') }}

            <div v-if="rememberedCreditCardsOpened" class="pilulka-premium-payment__credit-cards-list">
                <div
                    v-for="card in userCreditCards"
                    :key="card.id"
                    class="pilulka-premium-payment__credit-card"
                    :class="{ 'pilulka-premium-payment__credit-card--selected': selectedCardId === card.id }"
                    @click.stop="selectCard(card.id)"
                >
                    <div class="pilulka-premium-payment__credit-card-radio">
                        <input
                            type="radio"
                            :checked="selectedCardId === card.id"
                            :value="card.id"
                            name="credit-card"
                            class="pilulka-premium-payment__credit-card-radio-input"
                        />
                    </div>
                    <div class="pilulka-premium-payment__credit-card-info">
                        <i class="fas fa-credit-card pilulka-premium-payment__credit-card-icon"></i>
                        <span class="pilulka-premium-payment__credit-card-number">{{ card.cardNumberMask }}</span>
                    </div>
                </div>

                <button
                    v-if="selectedCardId"
                    class="btn btn-primary pilulka-premium-payment__purchase-button"
                    @click.stop="purchaseWithSelectedCard"
                >
                    {{ $t('userProfile.payPilulkaPremiumForXPrice', { price: calculatedPrice || props.price }) }}
                </button>
            </div>
        </div>

        <div ref="cardContainer"></div>

        <div
            v-if="showOtherPayments && isLoaded"
            class="pilulka-premium-payment__other-payments"
            :class="{ 'pilulka-premium-payment__grey-db': otherPaymentsOpened }"
            @click="otherPaymentsClicked"
        >
            {{ $t('cart.premiumBox.anotherPaymentMethods') }}

            <div v-if="otherPaymentsOpened" class="pilulka-premium-payment__benefit-info">
                <div class="pilulka-premium-payment__benefit-info--content">
                    <div class="pilulka-premium-payment__benefit-info--icon">
                        <i class="fas fa-info-circle"></i>
                    </div>
                    <div class="pilulka-premium-payment__benefit-info--text">
                        <h5 class="mb-2">{{ $t('cart.premiumBox.benefitPaymentTitle') }}</h5>
                        <p class="mb-0">{{ $t('cart.premiumBox.benefitPaymentInfo') }}</p>
                    </div>
                </div>
                <div class="pilulka-premium-payment__benefit-info--action">
                    <button class="btn btn-primary" @click="addToBasketClicked">
                        {{ $t('cart.premiumBox.addToBasket') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="adyen__footer">
            <!--            <div class="adyen__footer__brands">-->
            <!--                <img src="https://www.pilulka.cz/images/png/adyen/adyen.png" width="40px" height="13px" alt="Adyen" />-->
            <!--                <img src="https://www.pilulka.cz/images/png/adyen/mastercard.png" width="22px" height="13px" alt="Mastercard" />-->
            <!--                <img src="https://www.pilulka.cz/images/png/adyen/visa.png" width="39px" height="13px" alt="Visa" />-->
            <!--            </div>-->
            <div class="adyen__footer__text">
                <img src="https://www.pilulka.cz/images/svg/savePaymentFooter.svg?v=1" width="12px" height="15px" alt="Pilulka" />
                <div v-html="$t('adyen.footerInfoText')"></div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted } from 'vue'
import { AdyenCheckout, Dropin, Card, GooglePay, ApplePay, GooglePayConfiguration, ApplePayConfiguration } from '@adyen/adyen-web'
import type { CoreConfiguration, DropinConfiguration } from '@adyen/adyen-web'
import '@adyen/adyen-web/styles/adyen.css'
import { useI18n } from 'vue-i18n'
import { useFlashMessagesStore } from '~/stores/flash_message'
import UserCreditCard from '~/models/Api/Cart/UserCreditCard'

const props = defineProps<{
    productId: number
    price: number
    showOtherPayments: boolean
    userCreditCards: UserCreditCard[]
    initialVoucherCode?: string
}>()

const rememberedCreditCardsOpened = ref(false)
const selectedCardId = ref<number | null>(null)
const voucherSectionOpened = ref(false)
const voucherCode = ref('')
const voucherConfirmed = ref(false)
const calculatedPrice = ref<number | null>(null)
const originalPrice = ref<number | null>(null)
const voucherErrorMessage = ref<string | null>(null)
const isCalculatingPrice = ref(false)

const openVoucherSection = () => {
    if (!voucherConfirmed.value) {
        voucherSectionOpened.value = !voucherSectionOpened.value
    }
}

const confirmVoucher = async () => {
    if (!voucherCode.value.trim()) {
        return
    }

    isCalculatingPrice.value = true
    voucherErrorMessage.value = null

    try {
        const response = await useNuxtApp().$repository.calculatePilulkaPremiumPrice(
            useAccessTokenCookie().value || '',
            props.productId,
            voucherCode.value
        )

        if (response.result && response.response) {
            if (response.response.voucherValid) {
                originalPrice.value = response.response.originalPrice
                calculatedPrice.value = response.response.finalPrice
                voucherConfirmed.value = true
                voucherSectionOpened.value = false

                // Reinitialize Adyen with new price
                await reinitializeAdyen()
            } else {
                voucherErrorMessage.value = response.response.errorMessage || i18n.t('cart.premiumBox.voucherInvalid')
            }
        } else {
            voucherErrorMessage.value = i18n.t('cart.premiumBox.voucherCalculationFailed')
        }
    } catch (error) {
        console.error('Voucher calculation error:', error)
        voucherErrorMessage.value = i18n.t('cart.premiumBox.voucherCalculationFailed')
    } finally {
        isCalculatingPrice.value = false
    }
}

const changeVoucher = () => {
    voucherConfirmed.value = false
    voucherSectionOpened.value = true
    calculatedPrice.value = null
    originalPrice.value = null
    voucherErrorMessage.value = null
}

const removeVoucher = async () => {
    voucherCode.value = ''
    voucherConfirmed.value = false
    voucherSectionOpened.value = false
    calculatedPrice.value = null
    originalPrice.value = null
    voucherErrorMessage.value = null

    // Reinitialize Adyen with original price
    await reinitializeAdyen()
}

const openRememberedCreditCards = () => {
    rememberedCreditCardsOpened.value = true
    otherPaymentsOpened.value = false

    if (props.userCreditCards.length > 0 && !selectedCardId.value) {
        selectedCardId.value = props.userCreditCards[0].id
    }

    dropin.value?.closeActivePaymentMethod()
}

const selectCard = (cardId: number) => {
    selectedCardId.value = cardId
}

const activatePremiumWithCard = async (userCreditCardId: number) => {
    const flashStore = useFlashMessagesStore()

    const activationResponse = await useNuxtApp().$repository.activatePilulkaPremium(
        useAccessTokenCookie().value || '',
        props.productId,
        userCreditCardId,
        voucherConfirmed.value ? voucherCode.value : undefined
    )

    if (!activationResponse.result) {
        flashStore.addNextMessage({
            message: i18n.t('userProfile.pilulkaPremiumWasNotActivated'),
            type: 'error',
        })

        return
    }

    flashStore.addNextMessage({
        message: i18n.t('userProfile.pilulkaPremiumActivated'),
        type: 'success',
    })

    // Pokud jsou GET parametry, přesměruj na stejnou stránku bez nich
    if (window.location.search) {
        window.location.href = window.location.pathname // + window.location.hash
    } else {
        window.location.reload()
    }
}

const purchaseWithSelectedCard = async () => {
    if (!selectedCardId.value) {
        return
    }

    await activatePremiumWithCard(selectedCardId.value)
}

const otherPaymentsOpened = ref(false)
const otherPaymentsClicked = () => {
    otherPaymentsOpened.value = true
    rememberedCreditCardsOpened.value = false

    dropin.value?.closeActivePaymentMethod()
}

const i18n = useI18n()
const errorMessage = ref('')

const emit = defineEmits(['addToBasketClicked'])
const isLoaded = ref(false)

const addToBasketClicked = () => {
    emit('addToBasketClicked')
}

const cardContainer = ref<HTMLElement | null>(null)
const dropin = ref<Dropin | null>(null)
const adyenSession = ref<any>(null)

const initializeAdyen = async () => {
    if (!adyenSession.value) {
        return
    }

    const sessionResponse = adyenSession.value
    const currentPrice = calculatedPrice.value || props.price

    const globalConfiguration: CoreConfiguration = {
        session: {
            id: sessionResponse.response.sessionId,
            sessionData: sessionResponse.response.sessionData,
        },
        environment: sessionResponse.response.environment,
        amount: {
            value: 0,
            currency: sessionResponse.response.currency,
        },
        locale: sessionResponse.response.locale,
        countryCode: sessionResponse.response.countryCode,
        clientKey: sessionResponse.response.clientKey,
        translations: {
            'cs-CZ': {
                'payButton.saveDetails': i18n.t('userProfile.payPilulkaPremiumForXPrice', { price: currentPrice }),
            },
            'sk-SK': {
                'payButton.saveDetails': i18n.t('userProfile.payPilulkaPremiumForXPrice', { price: currentPrice }),
            },
        },
        async onPaymentCompleted() {
            try {
                const flashStore = useFlashMessagesStore()

                const userCreditCardResponse = await useNuxtApp().$repository.storeUserCreditCard(useAccessTokenCookie().value || '')
                if (!userCreditCardResponse.result || userCreditCardResponse.response.lastCreditCardId === null) {
                    flashStore.addNextMessage({
                        message: i18n.t('userProfile.pilulkaPremiumWasNotActivated'),
                        type: 'error',
                    })

                    return
                }

                const userCreditCardId = userCreditCardResponse.response.lastCreditCardId
                await activatePremiumWithCard(userCreditCardId)
            } catch (error) {
                console.error('Payment verification error:', error)
                errorMessage.value = i18n.t('userProfile.paymentVerificationFailed')
            }
        },
        onPaymentFailed(result) {
            console.log('onPaymentFailed', result)

            errorMessage.value = i18n.t('userProfile.cardRememberingFailed')
        },
        onError: (error, component) => {
            console.error(error.name, error.message, error.stack, component)
        },
    }

    const checkout = await AdyenCheckout(globalConfiguration)

    let isFirstOnSelect = true

    const applePayConfiguration: ApplePayConfiguration = {
        // configuration: {
        //     merchantId: sessionResponse.response.applePayMerchantIdentifier,
        //     merchantName: 'Pilulka',
        // },
        totalPriceLabel: 'Pilulka PRO',
    }

    const googlePayConfiguration: GooglePayConfiguration = sessionResponse.response.googlePayMerchantId
        ? {
              configuration: {
                  merchantId: sessionResponse.response.googlePayMerchantId,
                  merchantName: sessionResponse.response.googlePayMerchantName,
                  gatewayMerchantId: sessionResponse.response.googlePayGatewayMerchantId,
              },
          }
        : {}

    const paymentMethodComponents: (typeof Card | typeof ApplePay | typeof GooglePay)[] = [Card, ApplePay]
    if (sessionResponse.response.googlePayMerchantId) {
        paymentMethodComponents.push(GooglePay)
    }

    const dropinConfiguration: DropinConfiguration = {
        paymentMethodComponents,
        paymentMethodsConfiguration: {
            googlepay: googlePayConfiguration,
            applepay: applePayConfiguration,
        },
        showStoredPaymentMethods: false,
        onSelect() {
            if (!isFirstOnSelect) {
                otherPaymentsOpened.value = false
                rememberedCreditCardsOpened.value = false
            } else {
                openRememberedCreditCards()
                isFirstOnSelect = false
            }
        },
        onReady() {
            isLoaded.value = true
            if (props.userCreditCards.length > 0) {
                openRememberedCreditCards()
            }
        },
    }

    dropin.value = new Dropin(checkout, dropinConfiguration)

    if (cardContainer.value) {
        dropin.value.mount(cardContainer.value)
    }
}

const reinitializeAdyen = async () => {
    // Unmount current dropin
    if (dropin.value) {
        try {
            dropin.value.unmount()
        } catch (error) {
            console.log('Error unmounting Adyen dropin during reinit:', error)
        }
        dropin.value = null
    }

    // Reinitialize with new price
    await initializeAdyen()
}

onMounted(async () => {
    adyenSession.value = await useNuxtApp().$repository.createCreditCardSession(useAccessTokenCookie().value || '')
    await initializeAdyen()

    // Auto-apply voucher code if provided
    if (props.initialVoucherCode) {
        voucherCode.value = props.initialVoucherCode
        voucherSectionOpened.value = true
        await confirmVoucher()
    }
})

onUnmounted(() => {
    if (dropin.value) {
        try {
            dropin.value.unmount()
        } catch (error) {
            console.log('Error unmounting Adyen dropin:', error)
        }
        dropin.value = null
    }

    // Reset component state
    errorMessage.value = ''
    isLoaded.value = false
    otherPaymentsOpened.value = false
})
</script>

<style scoped lang="scss">
.pilulka-premium-payment {
    &__grey-db {
        background: #f7f7f8;
    }

    &__voucher-section {
        cursor: pointer;
        margin-bottom: 16px;
        align-items: center;
        color: #00112c;
        display: block;
        flex-wrap: nowrap;
        font-size: 1rem;
        font-weight: 400;
        justify-content: space-between;
        padding: 16px;
        position: relative;
        transition: background 0.1s ease-out;
        width: 100%;
        border: 1px solid #dbdee2;
        border-radius: 8px;
    }

    &__voucher-content {
        margin-top: 16px;
        cursor: default;
    }

    &__voucher-label {
        display: block;
        margin-bottom: 8px;
        font-size: 14px;
        font-weight: 500;
        color: #00112c;
    }

    &__voucher-input {
        width: 100%;
        padding: 12px;
        font-size: 16px;
        border: 1px solid #dbdee2;
        border-radius: 8px;
        transition: border-color 0.2s ease;
        margin-bottom: 12px;

        &:focus {
            outline: none;
            border-color: #4cb748;
        }

        &::placeholder {
            color: #999;
        }
    }

    &__voucher-button {
        width: 100%;
        padding: 12px;
        font-weight: 600;

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }

    &__voucher-confirmed {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        padding: 12px;
        background: #e8f5e9;
        border: 1px solid #4cb748;
        border-radius: 8px;
        cursor: default;
    }

    &__voucher-confirmed-content {
        display: flex;
        align-items: center;
        gap: 12px;
        flex: 1;
    }

    &__voucher-confirmed-icon {
        color: #4cb748;
        font-size: 20px;
        flex-shrink: 0;
    }

    &__voucher-confirmed-text {
        flex: 1;
        font-size: 14px;
        font-weight: 500;
        color: #00112c;
    }

    &__price-info {
        margin-top: 4px;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 16px;
    }

    &__original-price {
        text-decoration: line-through;
        color: #999;
        font-weight: 400;
    }

    &__final-price {
        color: #4cb748;
        font-weight: 700;
        font-size: 18px;
    }

    &__voucher-actions {
        display: flex;
        gap: 8px;
        flex-shrink: 0;
    }

    &__voucher-change {
        background: transparent;
        border: 1px solid #4cb748;
        color: #4cb748;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        padding: 6px 12px;
        border-radius: 6px;
        transition: all 0.2s ease;

        &:hover {
            background: #4cb748;
            color: white;
        }
    }

    &__voucher-remove {
        background: transparent;
        border: 1px solid #d32f2f;
        color: #d32f2f;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        padding: 6px 12px;
        border-radius: 6px;
        transition: all 0.2s ease;

        &:hover {
            background: #d32f2f;
            color: white;
        }
    }

    &__remembered-credit-cards {
        cursor: pointer;
        margin-bottom: 16px;
        align-items: center;
        color: #00112c;
        display: block;
        flex-wrap: nowrap;
        font-size: 1rem;
        font-weight: 400;
        justify-content: space-between;
        padding: 16px;
        position: relative;
        transition: background 0.1s ease-out;
        width: 100%;
        border: 1px solid #dbdee2;
        border-radius: 8px;
    }

    &__other-payments {
        cursor: pointer;
        margin-top: 16px;
        align-items: center;
        color: #00112c;
        display: block;
        flex-wrap: nowrap;
        font-size: 1rem;
        font-weight: 400;
        justify-content: space-between;
        padding: 16px;
        position: relative;
        transition: background 0.1s ease-out;
        width: 100%;
        border: 1px solid #dbdee2;
        border-radius: 8px;
    }

    &__credit-cards-list {
        margin-top: 16px;
    }

    &__credit-card {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 16px;
        margin-bottom: 8px;
        cursor: pointer;
    }

    &__credit-card-radio {
        display: flex;
        align-items: center;
    }

    &__credit-card-radio-input {
        width: 20px;
        height: 20px;
        cursor: pointer;
    }

    &__credit-card-info {
        display: flex;
        align-items: center;
        gap: 12px;
        flex: 1;
    }

    &__credit-card-icon {
        font-size: 20px;
        color: #00112c;
    }

    &__credit-card-number {
        font-size: 16px;
        font-weight: 500;
        color: #00112c;
    }

    &__purchase-button {
        width: 100%;
        margin-top: 16px;
        padding: 12px;
        font-weight: 600;
    }

    &__benefit-info {
        background: #fff4e0;
        border: 2px solid #c97b19;
        border-radius: 10px;
        padding: 20px;
        margin: 20px 0;

        &--content {
            display: flex;
            align-items: flex-start;
            margin-bottom: 15px;
        }

        &--icon {
            color: #c97b19;
            font-size: 20px;
            margin-right: 15px;
            margin-top: 2px;
        }

        &--text {
            flex: 1;

            h5 {
                color: #333;
                font-weight: bold;
            }

            p {
                color: #666;
                font-size: 14px;
            }
        }

        &--action {
            text-align: center;

            .btn {
                padding: 10px 30px;
                font-weight: bold;
            }
        }
    }
}
.adyen__box {
    background: rgba(76, 183, 72, 0.05);
    border: 1px solid #4cb748;
    border-radius: 10px;
    padding: 18px;
    text-align: center;
}

.adyen__claim {
    border-radius: 10px;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #333;
    text-align: center;
    display: flex;
    justify-content: space-between;

    &--add-info {
        font-weight: 590;
        font-size: 14px;
        margin: 18px auto 0 auto;
        padding: 0;
        letter-spacing: -0.3px;
        line-height: 16px;
    }

    svg {
        margin-right: 15px;
    }
}

.adyen__footer {
    //background: $color-yellow-light;
    //padding: 20px 0 20px;
    margin-top: 20px;
    border-radius: 10px;
    font-size: 13px;

    &__brands {
        display: flex;
        margin: 0 0 20px;
        justify-content: center;

        img {
            margin: 0 25px;
        }
    }

    &__text {
        display: flex;
        padding: 0 20px 0 0;
        text-align: left;

        img {
            margin-right: 10px;
            margin-top: 5px;
        }
    }
}
</style>
